const dropdown = (trigger) => {
  if (trigger.length != 0) {
    trigger[0].classList.add("tab-open");
    for (var i = 0; i < trigger.length; i++) {
      trigger[i].addEventListener("click", function () {
        var classes = this.parentNode.getAttribute("class");
        closeAllTabs();
        if (classes.indexOf("tab-open") == -1) {
          this.parentNode.classList.toggle("tab-open");
        }
      });
    }
    function closeAllTabs() {
      for (var i = 0; i < trigger.length; i++) {
        trigger[i].parentNode.classList.remove("tab-open");
      }
    }
  }
};
export { dropdown };

const initMobileNavDropdown = () => {
  const parentsMenuItems = document.querySelectorAll(
    "#primary-menu .menu-item-has-children"
  );
  parentsMenuItems.forEach((parentMenu) => {
    const arrow = document.createElement("div");
    arrow.classList.add("menu-arrow");
    parentMenu.appendChild(arrow);
    arrow.addEventListener("click", function () {
      this.parentNode.classList.toggle("show-submenu");
    });
  });
  dropdown(document.querySelectorAll(".menu-arrow"));
};

export { initMobileNavDropdown };
